var map = {
	"./img22-1.png": 36739,
	"./img22.png": 17685,
	"./tips.png": 54486,
	"./tips1.png": 89819,
	"./tips10.png": 46007,
	"./tips11.png": 60583,
	"./tips12.png": 78683,
	"./tips2.png": 12605,
	"./tips3.png": 549,
	"./tips4.png": 88821,
	"./tips5.png": 96342,
	"./tips6.png": 36572,
	"./tips7.png": 46457,
	"./tips8.png": 57389,
	"./tips9.png": 55742
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24116;